import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { sum } from 'lodash';

import { BarGraph } from 'frontend-component-library';

class RemainderBarGraph extends PureComponent {
  render() {
    const { percentages, schema } = this.props;
    const percentage = Math.round(100 - sum(percentages));
    return (
      <BarGraph
        className={`RemainderBarGraph-${schema}`}
        title="Other"
        percentage={percentage}
      />
    );
  }
}

// schema corresponds to the tag type that the list is displaying.
RemainderBarGraph.propTypes = {
  schema: PropTypes.string.isRequired,
  percentages: PropTypes.arrayOf(PropTypes.number).isRequired,
  topTags: PropTypes.array.isRequired,
};

export default RemainderBarGraph;



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/RankedLists/RemainderBarGraph.js